/* eslint-disable import/no-anonymous-default-export */
import axios from './BASE_API'
import AuthHeader from './AuthHeader'

// class define
class LeadServiceAPI {
  // apply for leave
  createLead: any = (data: any) => {
    return axios.post('/lead/add', data, {headers: AuthHeader()})
  }
  editLead: any = (data: any) => {
    return axios.put('/lead/update', data, {headers: AuthHeader()})
  }
  deleteLead: any = (id: number) => {
    return axios.delete(`/lead/delete`, {
      data: {
        id: id as number,
      },
      headers: AuthHeader(),
    })
  }
  getLeadDetails: any = (id: number) => {
    return axios.get('/lead/details/' + id, {headers: AuthHeader()})
  }
  getActivityDetails: any = (id: number) => {
    return axios.get('/lead/activity-details/' + id, {headers: AuthHeader()})
  }
  // apply for leave
  resetPassword: any = (data: any) => {
    return axios.post('/user/reset-password-confirm', data, {headers: AuthHeader()})
  }

  // update company profile
  updateCompanyProfile: any = (data: any) => {
    return axios.put('/company/update', data, {headers: AuthHeader()})
  }
  getCompanyDetails: any = (id: number) => {
    return axios.get('/company/details/' + id, {headers: AuthHeader()})
  }
  updateCompanyLogo: any = (data: any) => {
    return axios.put('/company/update-logo', data, {headers: AuthHeader()})
  }

  getLeadStatus: any = () => {
    return axios.get('/lead-status/activeList', {headers: AuthHeader()})
  }

  getLeadOwnerList: any = () => {
    return axios.get('/company/user-list', {headers: AuthHeader()})
  }

  getCustomerList: any = (data: any) => {
    return axios.post('/lead/customer-list-for-company', data, {headers: AuthHeader()})
    // return axios.post('/lead/company-customer-list', data, {headers: AuthHeader()})
  }
  getLeadList: any = (data: any) => {
    return axios.post('/lead/lead-list-for-company', data, {headers: AuthHeader()})
  }
  getMixedLeadList: any = (data: any) => {
    return axios.post('/lead/company-list-for-company', data, {headers: AuthHeader()})
  }
  getCompanyUserList: any = () => {
    return axios.get('/company/user-list', {headers: AuthHeader()})
  }
  getContactListIndividual: any = (data: any) => {
    return axios.post('/lead/my-mixed-list', data, {headers: AuthHeader()})
  }
  getLeadListIndividual: any = (data: any) => {
    return axios.post('/lead/my-lead-list', data, {headers: AuthHeader()})
  }
  getCustomerListIndividual: any = (data: any) => {
    return axios.post('/lead/my-customer-list', data, {headers: AuthHeader()})
  }
  getCompanyListIndividual: any = (data: any) => {
    return axios.post('/lead/my-company-list', data, {headers: AuthHeader()})
  }
  createNote: any = (data: any) => {
    return axios.post('/lead/add-note', data, {headers: AuthHeader()})
  }
  sendEmail: any = (data: any) => {
    return axios.post('/lead/send-email', data, {headers: AuthHeader()})
  }
  sendSMS: any = (data: any) => {
    return axios.post('/lead/send-sms', data, {headers: AuthHeader()})
  }
  editNote: any = (data: any) => {
    return axios.put('/lead/update-note', data, {headers: AuthHeader()})
  }
  getAllActivityList: any = (data: any) => {
    return axios.post('/lead/activity-list', data, {headers: AuthHeader()})
  }
  getNotesList: any = (data: any) => {
    return axios.post('/lead/activity-list', data, {headers: AuthHeader()})
  }
  getEmailList: any = (data: any) => {
    return axios.post('/lead/activity-list', data, {headers: AuthHeader()})
  }
  getSMSList: any = (data: any) => {
    return axios.post('/lead/activity-list', data, {headers: AuthHeader()})
  }
  downloadLead: any = (data: any) => {
    return axios.post('/lead/upload-lead', data, {headers: AuthHeader()})
  }
  getAllContactList: any = (data: any) => {
    return axios.post('/lead/company-mixed-list-all', data, {headers: AuthHeader()})
  }
  getAllLeadList: any = (data: any) => {
    return axios.post('/lead/lead-list-for-company-all', data, {headers: AuthHeader()})
  }
  getAllCustomerList: any = (data: any) => {
    return axios.post('/lead/customer-list-for-company-all', data, {headers: AuthHeader()})
  }
  getAllCompanyList: any = (data: any) => {
    return axios.post('/lead/company-list-for-company-all', data, {headers: AuthHeader()})
  }
}

export default new LeadServiceAPI()
